

const findDuplicates = (CustomerReferenceNumber, grid) => {
    const arrayForSort = [...grid]
    let sorted_grid = arrayForSort.filter(x => x.CustomerReferenceNumber && x.CustomerReferenceNumber.trim() != '').map((x, index) => ({ index, CustomerReferenceNumber: x.CustomerReferenceNumber })).sort(function (a, b) {
        return ('' + a.CustomerReferenceNumber).localeCompare(b.CustomerReferenceNumber);
    });
    let results = [];
    for (let i = 0; i < sorted_grid.length - 1; i++) {
        if (sorted_grid[i + 1].CustomerReferenceNumber == sorted_grid[i].CustomerReferenceNumber) {
            results.push(sorted_grid[i]);
        }
    }
    return results.findIndex(d => d.CustomerReferenceNumber.trim().toUpperCase() == CustomerReferenceNumber.trim().toUpperCase()) !== -1;
}


export const calculateErrors = (grid, userInfo) => {
    let errorsOccured = [];
    grid.map((element, index) => {
        Object.keys(element).map(key => {
            let gridObj = {
                'Consignment': () => {
                    if (!element[key] || element[key] === "") {
                        errorsOccured.push({
                            index,
                            key,
                            error: "Consignment Number is Required",
                            fieldName: "Consignment"
                        })
                    } else {
                        if (element[key].length > 49) {
                            errorsOccured.push({
                                index,
                                key,
                                error: "Maximum length is 50 characters.",
                                fieldName: "Consignment"

                            })
                        }
                    }
                },
                'CustomerReferenceNumber': () => {
                    if (!element[key] || element[key] === "") {
                        errorsOccured.push({
                            index,
                            key,
                            error: "Customer Reference Number is Required.",
                            fieldName: "Customer Reference Number"
                        })
                    } else {
                        if (!userInfo.isDuplicateOrderAllowed && findDuplicates(element[key], grid)) {
                            errorsOccured.push({
                                index,
                                key,
                                error: "Duplicate Customer Reference Number not allowed.",
                                fieldName: "Customer Reference Number"
                            })
                        }
                    }
                },
                'ICCID': () => {
                    if (!element[key] || element[key] === "") {
                        errorsOccured.push({
                            index,
                            key,
                            error: "ICCID is Required.",
                            fieldName: "ICCID"
                        })
                    } else {
                        if (element[key].length > 49) {
                            errorsOccured.push({
                                index,
                                key,
                                error: "Maximum length is 50 characters.",
                                fieldName: "ICCID"
                            })
                        }
                    }
                },
                'default': () => (console.log())
            };
            let executeValidation = gridObj[key] || gridObj['default'];
            return executeValidation();
        })
    })

    return errorsOccured;
}